/**
 * Баланс беты: только отличия поверх основных данных (overlay), не копия. Объекты сливаются по ключам, массивы с
 * `{ "$add": [...] }` дописываются в конец, остальное заменяется. Обычный режим этих файлов не читает.
 */
import { BalanceData } from "@newfungame/contracts";
import { balanceV1 } from "../index";
import beta from "./beta.json";
import heroes from "./heroes.json";
import skills from "./skills.json";
import tech from "./tech.json";
import waves from "./waves.json";

/** Версия данных беты (`beta-YYYY-MM-DD.N`): попадает в журнал волны и в реестр версий сервера. */
export const BETA_BALANCE_VERSION = "beta-2026-11-04.1";

/** Сырой overlay беты — для тестов и инструментов баланса. */
export const betaOverlay = { version: BETA_BALANCE_VERSION, waves, heroes, skills, tech, beta };

type Json = null | boolean | number | string | Json[] | { [k: string]: Json };
const isObj = (x: unknown): x is { [k: string]: Json } => typeof x === "object" && x !== null && !Array.isArray(x);

/** Слияние overlay в основу: объекты — по ключам, `{ $add }` — дописать в массив, иное — заменить. */
export function mergeOverlay(base: Json, over: Json): Json {
  if (isObj(over) && Array.isArray(over.$add) && Array.isArray(base)) return [...base, ...over.$add];
  if (isObj(over) && isObj(base)) {
    const out: { [k: string]: Json } = { ...base };
    for (const [k, v] of Object.entries(over)) out[k] = k in base ? mergeOverlay(base[k]!, v) : v;
    return out;
  }
  return over;
}

/** Баланс беты: основной баланс + overlay, проверенный схемой. */
export function loadBetaBalance(base: BalanceData = balanceV1): BalanceData {
  return BalanceData.parse(mergeOverlay(base as unknown as Json, betaOverlay as unknown as Json));
}

let cached: BalanceData | undefined;
/**
 * Баланс беты, собранный при первом обращении. Не константа модуля: клиент обычной игры тянет engine целиком, а разбор
 * данных беты при загрузке модуля попал бы в бюджет первой загрузки (оверлей и схема отбрасываются сборкой, пока им не пользуются).
 */
export const getBetaBalance = (): BalanceData => (cached ??= loadBetaBalance());
